import { Injectable } from '@angular/core';
import {MessageService} from '../base/message.service';
import {HttpClient, HttpParams} from '@angular/common/http';

import {Service} from '../base/service';
import {Loggers} from '../../../util/app-util';
import {asesorEntity} from '../../../elements/riesgo-credito/entities_riesgos/entities_riesgos';
import { CookieService } from 'ngx-cookie-service';
@Injectable({
  providedIn: 'root'
})
export class AsesorService extends Service<asesorEntity>{
  httpClient: HttpClient;
  constructor(
      http: HttpClient,
      messageService: MessageService,
      protected override logger: Loggers,
      cookiesService: CookieService
    ) { 
      super('concentracion','',http, messageService, logger, cookiesService);
      this.httpClient = http;
    }
  protected getParams(entity: asesorEntity):HttpParams{
    let params: HttpParams = new HttpParams();
    if (null == entity){return params;}
    if (null != entity.AsesorId){params = params.set('AsesorId', entity.AsesorId.toString())}
    if (null != entity.InstitucionId){params = params.set('InstitucionId', entity.InstitucionId.toString())}
    return params;
  }
}
